import { LocaleKeys } from '../../../../locale/translation-types'
import type { Staff } from '../../models/staff/staff'

export enum StaffQualificationEnum {
  PROFESSOR_ENGLISH = 'PROFESSOR_ENGLISH',
  PROFESSOR_ENGLISH_PREPA_SUP = 'PROFESSOR_ENGLISH_PREPA_SUP',
  PROFESSOR_SPANISH = 'PROFESSOR_SPANISH',
  PROFESSOR_ENGLISH_COLLEGE = 'PROFESSOR_ENGLISH_COLLEGE',
  PROFESSOR_GERMAN = 'PROFESSOR_GERMAN',
  COORDINATING_PROFESSOR = 'COORDINATING_PROFESSOR',
  REFERENT = 'REFERENT',
  TEFL = 'TEFL',
  FAC_TERRAIN = 'FAC_TERRAIN',
  FAC_PARIS = 'FAC_PARIS',
  DIRECTOR = 'DIRECTOR',
  DEPUTY = 'DEPUTY',
  FH_ANIMATOR = 'FH_ANIMATOR',
  BAFA_ANIMATOR = 'BAFA_ANIMATOR',
  SANITARY_ASSISTANT_ANIMATOR = 'SANITARY_ASSISTANT_ANIMATOR',
  SWIMMING_MONITOR_ANIMATOR = 'SWIMMING_MONITOR_ANIMATOR',
  ACTIVITY_LEADER = 'ACTIVITY_LEADER',
  THEME_FOOTBALL_TRAINER = 'THEME_FOOTBALL_TRAINER',
  THEME_BASKETBALL_TRAINER = 'THEME_BASKETBALL_TRAINER',
  THEME_TENNIS_TRAINER = 'THEME_TENNIS_TRAINER',
  THEME_CHESS_TRAINER = 'THEME_CHESS_TRAINER',
  THEME_MANGA_PROFESSOR = 'THEME_MANGA_PROFESSOR',
  THEME_DANCE_PROFESSOR = 'THEME_DANCE_PROFESSOR',
  THEME_THEATER_PROFESSOR = 'THEME_THEATER_PROFESSOR',
  THEME_MUSIC_PROFESSOR = 'THEME_MUSIC_PROFESSOR',
  THEME_FOOTBALL_COACH = 'THEME_FOOTBALL_COACH',
  THEME_BASKETBALL_COACH = 'THEME_BASKETBALL_COACH',
  THEME_TENNIS_COACH = 'THEME_TENNIS_COACH',
  THEME_CHESS_COACH = 'THEME_CHESS_COACH',
  THEME_MANGA_COACH = 'THEME_MANGA_COACH',
  THEME_DANCE_COACH = 'THEME_DANCE_COACH',
  THEME_DRAMA_COACH = 'THEME_DRAMA_COACH',
  THEME_MUSIC_COACH = 'THEME_MUSIC_COACH',
  THEME_FOOTBALL_COACH_DAILY = 'THEME_FOOTBALL_COACH_DAILY',
  THEME_BASKETBALL_COACH_DAILY = 'THEME_BASKETBALL_COACH_DAILY',
  THEME_TENNIS_COACH_DAILY = 'THEME_TENNIS_COACH_DAILY',
  THEME_CHESS_COACH_DAILY = 'THEME_CHESS_COACH_DAILY',
  THEME_MANGA_COACH_DAILY = 'THEME_MANGA_COACH_DAILY',
  THEME_DANCE_COACH_DAILY = 'THEME_DANCE_COACH_DAILY',
  THEME_DRAMA_COACH_DAILY = 'THEME_DRAMA_COACH_DAILY',
  THEME_MUSIC_COACH_DAILY = 'THEME_MUSIC_COACH_DAILY',
  PROVINCE_CONVEYOR = 'PROVINCE_CONVEYOR',
  FOREIGN_CONVEYOR = 'FOREIGN_CONVEYOR',
  STATION_ASSISTANT = 'STATION_ASSISTANT'
}

export type QualificationColor = {
  background: string
  text: string
}

// Colors taken from the BIWEB job-position colors (see Trello card "Qualification des ME > Ajouter des couleurs")
export const qualificationColors = {
  professor: { background: '#BFD2E0', text: '#2C5875' },
  professorCollege: { background: '#CC99FF', text: '#4B1F82' },
  referent: { background: '#FAA7F3', text: '#8A1F6E' },
  fhAnimator: { background: '#FFFF95', text: '#6B6200' },
  animator: { background: '#DBC5FF', text: '#5B2D90' },
  theme: { background: '#FFB380', text: '#8A4500' },
  fac: { background: '#72A3C4', text: '#FFFFFF' },
  direction: { background: '#8D5FBA', text: '#FFFFFF' },
  provinceConveyor: { background: '#FF99FF', text: '#861F86' },
  foreignConveyor: { background: '#00B0F0', text: '#FFFFFF' },
  stationAssistant: { background: '#9966FF', text: '#FFFFFF' }
} satisfies Record<string, QualificationColor>

export const staffQualificationEnumMapping: Record<
  StaffQualificationEnum,
  {
    label: LocaleKeys
    type: 'french' | 'foreign'
    profession: 'course' | 'activity' | 'aat' | 'encadrement'
    color: QualificationColor
  }
> = {
  [StaffQualificationEnum.ACTIVITY_LEADER]: {
    label: 'staff.qualification.enum.ACTIVITY_LEADER',
    type: 'foreign',
    profession: 'activity',
    color: qualificationColors.animator
  },
  [StaffQualificationEnum.PROVINCE_CONVEYOR]: {
    label: 'staff.qualification.enum.PROVINCE_CONVEYOR',
    type: 'french',
    profession: 'aat',
    color: qualificationColors.provinceConveyor
  },
  [StaffQualificationEnum.BAFA_ANIMATOR]: {
    label: 'staff.qualification.enum.BAFA_ANIMATOR',
    type: 'french',
    profession: 'activity',
    color: qualificationColors.animator
  },
  [StaffQualificationEnum.COORDINATING_PROFESSOR]: {
    label: 'staff.qualification.enum.COORDINATING_PROFESSOR',
    type: 'french',
    profession: 'course',
    color: qualificationColors.professor
  },
  [StaffQualificationEnum.DEPUTY]: {
    label: 'staff.qualification.enum.DEPUTY',
    type: 'french',
    profession: 'encadrement',
    color: qualificationColors.direction
  },
  [StaffQualificationEnum.DIRECTOR]: {
    label: 'staff.qualification.enum.DIRECTOR',
    type: 'french',
    profession: 'encadrement',
    color: qualificationColors.direction
  },
  [StaffQualificationEnum.FAC_PARIS]: {
    label: 'staff.qualification.enum.FAC_PARIS',
    type: 'french',
    profession: 'encadrement',
    color: qualificationColors.fac
  },
  [StaffQualificationEnum.FAC_TERRAIN]: {
    label: 'staff.qualification.enum.FAC_TERRAIN',
    type: 'french',
    profession: 'encadrement',
    color: qualificationColors.fac
  },
  [StaffQualificationEnum.PROFESSOR_ENGLISH_COLLEGE]: {
    label: 'staff.qualification.enum.PROFESSOR_ENGLISH_COLLEGE',
    type: 'french',
    profession: 'course',
    color: qualificationColors.professorCollege
  },
  [StaffQualificationEnum.FH_ANIMATOR]: {
    label: 'staff.qualification.enum.FH_ANIMATOR',
    type: 'french',
    profession: 'activity',
    color: qualificationColors.fhAnimator
  },
  [StaffQualificationEnum.FOREIGN_CONVEYOR]: {
    label: 'staff.qualification.enum.FOREIGN_CONVEYOR',
    type: 'french',
    profession: 'aat',
    color: qualificationColors.foreignConveyor
  },
  [StaffQualificationEnum.PROFESSOR_ENGLISH]: {
    label: 'staff.qualification.enum.PROFESSOR_ENGLISH',
    type: 'french',
    profession: 'course',
    color: qualificationColors.professor
  },
  [StaffQualificationEnum.PROFESSOR_ENGLISH_PREPA_SUP]: {
    label: 'staff.qualification.enum.PROFESSOR_ENGLISH_PREPA_SUP',
    type: 'french',
    profession: 'course',
    color: qualificationColors.professor
  },
  [StaffQualificationEnum.PROFESSOR_GERMAN]: {
    label: 'staff.qualification.enum.PROFESSOR_GERMAN',
    type: 'french',
    profession: 'course',
    color: qualificationColors.professor
  },
  [StaffQualificationEnum.PROFESSOR_SPANISH]: {
    label: 'staff.qualification.enum.PROFESSOR_SPANISH',
    type: 'french',
    profession: 'course',
    color: qualificationColors.professor
  },
  [StaffQualificationEnum.REFERENT]: {
    label: 'staff.qualification.enum.REFERENT',
    type: 'french',
    profession: 'course',
    color: qualificationColors.referent
  },
  [StaffQualificationEnum.SANITARY_ASSISTANT_ANIMATOR]: {
    label: 'staff.qualification.enum.SANITARY_ASSISTANT_ANIMATOR',
    type: 'french',
    profession: 'activity',
    color: qualificationColors.animator
  },
  [StaffQualificationEnum.STATION_ASSISTANT]: {
    label: 'staff.qualification.enum.STATION_ASSISTANT',
    type: 'french',
    profession: 'aat',
    color: qualificationColors.stationAssistant
  },
  [StaffQualificationEnum.SWIMMING_MONITOR_ANIMATOR]: {
    label: 'staff.qualification.enum.SWIMMING_MONITOR_ANIMATOR',
    type: 'french',
    profession: 'activity',
    color: qualificationColors.animator
  },
  [StaffQualificationEnum.TEFL]: {
    label: 'staff.qualification.enum.TEFL',
    type: 'foreign',
    profession: 'course',
    color: qualificationColors.professorCollege
  },
  [StaffQualificationEnum.THEME_BASKETBALL_COACH]: {
    label: 'staff.qualification.enum.THEME_BASKETBALL_COACH',
    type: 'foreign',
    profession: 'activity',
    color: qualificationColors.theme
  },
  [StaffQualificationEnum.THEME_BASKETBALL_TRAINER]: {
    label: 'staff.qualification.enum.THEME_BASKETBALL_TRAINER',
    type: 'french',
    profession: 'activity',
    color: qualificationColors.theme
  },
  [StaffQualificationEnum.THEME_CHESS_COACH]: {
    label: 'staff.qualification.enum.THEME_CHESS_COACH',
    type: 'foreign',
    profession: 'activity',
    color: qualificationColors.theme
  },
  [StaffQualificationEnum.THEME_CHESS_TRAINER]: {
    label: 'staff.qualification.enum.THEME_CHESS_TRAINER',
    type: 'french',
    profession: 'activity',
    color: qualificationColors.theme
  },
  [StaffQualificationEnum.THEME_DANCE_COACH]: {
    label: 'staff.qualification.enum.THEME_DANCE_COACH',
    type: 'foreign',
    profession: 'activity',
    color: qualificationColors.theme
  },
  [StaffQualificationEnum.THEME_DANCE_PROFESSOR]: {
    label: 'staff.qualification.enum.THEME_DANCE_PROFESSOR',
    type: 'french',
    profession: 'activity',
    color: qualificationColors.theme
  },
  [StaffQualificationEnum.THEME_DRAMA_COACH]: {
    label: 'staff.qualification.enum.THEME_DRAMA_COACH',
    type: 'foreign',
    profession: 'activity',
    color: qualificationColors.theme
  },
  [StaffQualificationEnum.THEME_FOOTBALL_COACH]: {
    label: 'staff.qualification.enum.THEME_FOOTBALL_COACH',
    type: 'foreign',
    profession: 'activity',
    color: qualificationColors.theme
  },
  [StaffQualificationEnum.THEME_FOOTBALL_TRAINER]: {
    label: 'staff.qualification.enum.THEME_FOOTBALL_TRAINER',
    type: 'french',
    profession: 'activity',
    color: qualificationColors.theme
  },
  [StaffQualificationEnum.THEME_MANGA_COACH]: {
    label: 'staff.qualification.enum.THEME_MANGA_COACH',
    type: 'foreign',
    profession: 'activity',
    color: qualificationColors.theme
  },
  [StaffQualificationEnum.THEME_MANGA_PROFESSOR]: {
    label: 'staff.qualification.enum.THEME_MANGA_PROFESSOR',
    type: 'french',
    profession: 'activity',
    color: qualificationColors.theme
  },
  [StaffQualificationEnum.THEME_MUSIC_COACH]: {
    label: 'staff.qualification.enum.THEME_MUSIC_COACH',
    type: 'foreign',
    profession: 'activity',
    color: qualificationColors.theme
  },
  [StaffQualificationEnum.THEME_MUSIC_PROFESSOR]: {
    label: 'staff.qualification.enum.THEME_MUSIC_PROFESSOR',
    type: 'french',
    profession: 'activity',
    color: qualificationColors.theme
  },
  [StaffQualificationEnum.THEME_TENNIS_COACH]: {
    label: 'staff.qualification.enum.THEME_TENNIS_COACH',
    type: 'foreign',
    profession: 'activity',
    color: qualificationColors.theme
  },
  [StaffQualificationEnum.THEME_TENNIS_TRAINER]: {
    label: 'staff.qualification.enum.THEME_TENNIS_TRAINER',
    type: 'french',
    profession: 'activity',
    color: qualificationColors.theme
  },
  [StaffQualificationEnum.THEME_THEATER_PROFESSOR]: {
    label: 'staff.qualification.enum.THEME_THEATER_PROFESSOR',
    type: 'french',
    profession: 'activity',
    color: qualificationColors.theme
  },
  [StaffQualificationEnum.THEME_FOOTBALL_COACH_DAILY]: {
    label: 'staff.qualification.enum.THEME_FOOTBALL_COACH_DAILY',
    type: 'foreign',
    profession: 'activity',
    color: qualificationColors.theme
  },
  [StaffQualificationEnum.THEME_BASKETBALL_COACH_DAILY]: {
    label: 'staff.qualification.enum.THEME_BASKETBALL_COACH_DAILY',
    type: 'foreign',
    profession: 'activity',
    color: qualificationColors.theme
  },
  [StaffQualificationEnum.THEME_TENNIS_COACH_DAILY]: {
    label: 'staff.qualification.enum.THEME_TENNIS_COACH_DAILY',
    type: 'foreign',
    profession: 'activity',
    color: qualificationColors.theme
  },
  [StaffQualificationEnum.THEME_CHESS_COACH_DAILY]: {
    label: 'staff.qualification.enum.THEME_CHESS_COACH_DAILY',
    type: 'foreign',
    profession: 'activity',
    color: qualificationColors.theme
  },
  [StaffQualificationEnum.THEME_MANGA_COACH_DAILY]: {
    label: 'staff.qualification.enum.THEME_MANGA_COACH_DAILY',
    type: 'foreign',
    profession: 'activity',
    color: qualificationColors.theme
  },
  [StaffQualificationEnum.THEME_DANCE_COACH_DAILY]: {
    label: 'staff.qualification.enum.THEME_DANCE_COACH_DAILY',
    type: 'foreign',
    profession: 'activity',
    color: qualificationColors.theme
  },
  [StaffQualificationEnum.THEME_DRAMA_COACH_DAILY]: {
    label: 'staff.qualification.enum.THEME_DRAMA_COACH_DAILY',
    type: 'foreign',
    profession: 'activity',
    color: qualificationColors.theme
  },
  [StaffQualificationEnum.THEME_MUSIC_COACH_DAILY]: {
    label: 'staff.qualification.enum.THEME_MUSIC_COACH_DAILY',
    type: 'foreign',
    profession: 'activity',
    color: qualificationColors.theme
  }
}

// Foreign OL spaces show their own English wording (Trello card 607); LEC side keeps `label`.
export const getOlStaffQualificationLabel = (qualification: StaffQualificationEnum): LocaleKeys =>
  `ol.staff.qualification.enum.${qualification}`

export const getStaffQualificationEnumFromMapping = (
  label: LocaleKeys
): StaffQualificationEnum => {
  return Object.entries(staffQualificationEnumMapping).find(
    ([, value]) => value.label === label
  )?.[0] as StaffQualificationEnum
}

export const frenchLeaderQualifications: StaffQualificationEnum[] = Object.values(
  StaffQualificationEnum
).filter((q) => staffQualificationEnumMapping[q].type === 'french')

export const isStaffEnglish = (staff?: Partial<Pick<Staff, 'qualifications'>> | null): boolean =>
  !!staff?.qualifications?.some((q) => staffQualificationEnumMapping[q].type === 'foreign')

export const getQualificationsCurrencySymbol = (
  staff?: Partial<Pick<Staff, 'qualifications'>> | null
): '€' | '£' => (isStaffEnglish(staff) ? '£' : '€')
